/**
 * Returns input returned as json.
 *
 * Useful for dumping objects
 */
export class JsonValueConverter {

    toView(obj) {
        try {
            return JSON.stringify(obj, null, 2);
        } catch (e) {
            return null;
        }
    }
}
